import { ReactComponent as DateIcon } from 'assets/icons/input_type_date.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/input_type_email.svg';
import { ReactComponent as NumberIcon } from 'assets/icons/input_type_number.svg';
import { ReactComponent as PasswordIcon } from 'assets/icons/input_type_password.svg';
import { ReactComponent as TextIcon } from 'assets/icons/input_type_text.svg';
import { ReactComponent as LabelAlignBottomIcon } from 'assets/icons/table_align_bottom.svg';
import { ReactComponent as LabelAlignMiddleIcon } from 'assets/icons/table_align_middle.svg';
import { ReactComponent as LabelAlignTopIcon } from 'assets/icons/table_align_top.svg';
import { HANDLE } from 'constants/bounding-box';

import { InputType, LabelAlignment } from './FormWidget.types';

export const BOUNDING_BOX_CONFIG = {
  customHandle: HANDLE.LEFT_RIGHT,
  rotatable: false,
};

export const DEFAULT_BACKGROUND_COLOR = '#00000000';
export const LABEL_ALIGNMENT_OPTIONS = [
  { value: LabelAlignment.start, label: 'top', icon: <LabelAlignTopIcon /> },
  { value: LabelAlignment.center, label: 'middle', icon: <LabelAlignMiddleIcon /> },
  { value: LabelAlignment.end, label: 'bottom', icon: <LabelAlignBottomIcon /> },
];

export const DEFAULT_FORM_FIELD_VALUE = {
  [InputType.Text]: { label: 'Name', type: InputType.Text, value: '', placeholder: 'eg. Lillian R. Mason' },
  [InputType.Email]: { label: 'Email', type: InputType.Email, value: '', placeholder: 'eg. Lillian@venngage.com' },
  [InputType.Password]: { label: 'Password', type: InputType.Password, value: '', placeholder: '***' },
  [InputType.Date]: { label: 'Date', type: InputType.Date, value: '', placeholder: '' },
  [InputType.Number]: { label: 'Number', type: InputType.Number, value: '', placeholder: '1234' },
};

export const INPUT_TYPE_OPTIONS = [
  {
    value: InputType.Text,
    label: 'text',
    icon: <TextIcon />,
  },
  {
    value: InputType.Email,
    label: 'email',
    icon: <EmailIcon />,
  },
  {
    value: InputType.Password,
    label: 'password',
    icon: <PasswordIcon />,
  },
  {
    value: InputType.Date,
    label: 'date',
    icon: <DateIcon />,
  },
  {
    value: InputType.Number,
    label: 'number',
    icon: <NumberIcon />,
  },
];

export const SHORT_QUESTION_INPUT_TEST_ID = 'form-short-question-input';
